interface EmailValidationResponse {
    isValid: boolean;
    isPersonalEmail: boolean;
    domain?: string;
    message?: string;
}

export const validateWorkEmail = async (email: string): Promise<EmailValidationResponse> => {
    try {
        const response = await fetch('/api/validate-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email }),
        });

        if (!response.ok) {
            // If API fails, return a default response
            return {
                isValid: true, // Don't block on API failure
                isPersonalEmail: false,
                message: 'Unable to validate email',
            };
        }

        return await response.json();
    } catch (error) {
        console.error('Email validation API error:', error);
        // If API fails, return a default response that doesn't block the user
        return {
            isValid: true, // Don't block on API failure
            isPersonalEmail: false,
            message: 'Unable to validate email',
        };
    }
};
